module.exports = __webpack_public_path__ + "img/app.af4f969.svg";